"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PodcastSearch_1 = require("../../components/PodcastSearch");
PodcastSearch_1.PodcastSearch.getInstance();
